import "./App.css";
import TheLayouts from "./views/pages/TheLayouts";

function App() {
  return (
    <div>
      <TheLayouts />
    </div>
  );
}

export default App;
